import styled from 'styled-components';
import { Button } from 'reactstrap';

export const UploadZone = styled.section`
  padding: 20px;
  text-align: center;
  background: ${props => (props.isFileDragOver ? '#f5fbff' : '#ffffff')};
  border: ${props => (props.isFileDragOver ? '2px' : '1px')} dashed
    ${props => (props.isFileDragOver ? '#0095ff' : '#acb7cd')};
  border-radius: 4px;
  margin: ${props => (props.isFileDragOver ? '-1px 0 9px 0' : '0 0 10px 0')};
  font-size: 14px;
  line-height: 20px;
  color: #6e7582;
`;

export const StyledButton = styled(Button)`
  color: #33373d;
  background-color: #bec5d3;
  border: none;
  &:hover {
    color: #ffffff;
    background-color: #575d67;
  }
`;

export const HiddenInputFile = styled.input`
  display: none;
`;
